import { trackEvent } from 'public/assets/js/analytics/track';
import { DocsAnalyticsBody } from '../../../components/docs/types';
import { DocsAction } from '../actionTypes';
import { DocsState } from '../reducer';

const ANALYTICS_DENYLIST: Array<DocsAction['type']> = [
  'GLOBAL_KEY_PRESSED',
  'SET_INITIAL_STATE',
  'SET_LOCALSTORAGE_DOCS_STATE',
  'SET_TOC_WAYPOINT',
];

const sanitizeState = (state: DocsState): DocsAnalyticsBody => {
  const {
    androidLanguage,
    apiVersion,
    clientPlatform,
    iOSLanguage,
    serverCodeLanguage,
    showSearch,
    searchQuery,
    searchResultText,
    searchResultPath,
    searchResultPosition,
    tableOfContentsActiveItem,
    openSearchClicked,
  } = state;

  return {
    androidLanguage,
    apiVersion,
    clientPlatform,
    iOSLanguage,
    serverCodeLanguage,
    showSearch,
    searchQuery,
    searchResultText,
    searchResultPath,
    searchResultPosition,
    tableOfContentsActiveItem,
    openSearchClicked,
  };
};

const analyticsMiddleware = (action: DocsAction, state: DocsState) => {
  if (ANALYTICS_DENYLIST.includes(action.type)) {
    return;
  }

  const payload = {
    ...sanitizeState(state),
    actionType: action.type,
    beta: true,
  };

  // Add card click data if this is a card click event
  if (action.type === 'CARD_CLICKED' && action.payload) {
    payload.cardType = action.payload.cardType;
    payload.cardTitle = action.payload.title;
    payload.cardLinkPath = action.payload.linkPath;
  }

  // Add redirect tracking data if this is a redirect event
  if (action.type === 'CLIENT_REDIRECT_USED' && action.payload) {
    payload.originalHash = action.payload.originalHash;
    payload.redirectPath = action.payload.redirectPath;
  }

  const tryOrRetryEvent = (payload: Record<string, unknown>) => {
    // window.analytics initialized asynchonously and doesnt have a way to communicate with this code
    // the best we can do is try again
    if (window.analytics == null || window.analytics.track == null) {
      setTimeout(() => {
        return tryOrRetryEvent(payload);
      }, 500);
      return;
    }

    trackEvent({ event: 'DOCS_EVENT', payload });
  };

  tryOrRetryEvent(payload);
};

export default analyticsMiddleware;
